// ─────────────────────────────────────────────────────────────────────
// WHO SEES MELDINGER IN THE CLUB PORTAL (#236, owner decision 2026-10-31).
//
// The club's correspondence (`messages_v1` on `/kv`) is read and written
// behind `messaging.send_as_organization` since 2026-10-31 — the right the
// server's own Meldinger surface asks for. A role without it is refused the
// blob with 403, so the portal must not draw the Meldinger icon, the dock or
// the view for that role, and must not poll a key it may not read.
//
// FOR DRAWING, NEVER FOR DECIDING. The server guards the key regardless; this
// only decides what the shell shows, from the same capability union `/me`
// reports (`useOrganizationCapabilities`) that the «Tilganger» entry reads.
// ─────────────────────────────────────────────────────────────────────

/** Spelled exactly as the API's catalog has it — a test reads both. */
export const MESSAGING_SEND_AS_ORGANIZATION = 'messaging.send_as_organization';

export interface PortalMessagingInputs {
  /** The capability union `/me` reports for the current scope; null = unknown. */
  capabilities: readonly string[] | null;
  /** Whether the browser talks to the API at all (`isApiMode()`). */
  apiMode: boolean;
  /** StarPoint operating AS the organization under an audited context (#976). */
  operatingAs: boolean;
}

/**
 * May this portal session use Meldinger?
 *
 *   • Off the API (the memory backend, tests, demos) there is no guard and no
 *     `/me`, so the answer is yes, as it always was.
 *   • An impersonation context grants every organization-derived capability
 *     of the one organization (auth/capabilities.ts), and `/me` reports no
 *     membership for it — so the context answers yes on its own.
 *   • Otherwise the union decides. NULL IS «UNKNOWN», NOT «NO»: while `/me` is
 *     still in flight nothing is drawn and nothing is polled, and the answer
 *     arrives with the union — the same rule the «Tilganger» door follows.
 */
export function portalMessagingAllowed(input: PortalMessagingInputs): boolean {
  if (!input.apiMode) return true;
  if (input.operatingAs) return true;
  return input.capabilities?.includes(MESSAGING_SEND_AS_ORGANIZATION) ?? false;
}
